module.exports = __webpack_public_path__ + "img/1000-item.dae66db9.png";